import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Avatar,
  Box,
  ButtonBase,
  Divider,
  Drawer,
  IconButton,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL, NO_USER_IMAGE } from "../../constants/Images";
import { logout } from "../../reduxStore/slices/authSlice";
import Iconify from "../iconify/Iconify";

const MENU_OPTIONS = [
  {
    label: "Profile",
    icon: "eva:person-fill",
  },
];

export default function AccountPopover({ onLock, onPinChanges }) {
  const { user } = useSelector((state) => state.auth);

  const [open, setOpen] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleHelpDrawer = () => {
    setOpenDrawer(true);
  };

  const handleClose = (action) => {
    setOpen(null);
    switch (action) {
      case "profile":
        navigate("/app/user-profile");
        break;
      case "lock":
        onLock(true);
        break;
      case "pinChanges":
        onPinChanges(true);
        break;
      case "help":
        handleHelpDrawer();
        break;
      case "logout":
        dispatch(logout());
        navigate("/login");
        break;
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap="10px">
        <IconButton sx={{ p: 0, position: "relative" }}>
          <Avatar
            src={
              user?.profile_pic
                ? `${IMAGE_URL}user/thumbnail?img_id=${user?.profile_pic}`
                : NO_USER_IMAGE
            }
            alt={user?.name}
          />
        </IconButton>

        <ButtonBase
          onClick={handleOpen}
          sx={{ borderRadius: 1, display: "flex", gap: "12px" }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body2" fontWeight="600" color="#000">
              {user?.name}
            </Typography>
            <Typography variant="caption" color="#000">
              ({user?.user_role_name})
            </Typography>
          </Box>
          <Iconify icon="mdi:chevron-down" width={20} color="#000" />
        </ButtonBase>
      </Box>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            position: "relative",
            p: 0,
            mt: 0.9,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClose("profile")}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem onClick={() => handleClose("pinChanges")} sx={{ m: 1 }}>
          Create Pin
        </MenuItem>
        <MenuItem onClick={() => handleClose("lock")} sx={{ m: 1 }}>
          Lock Screen
        </MenuItem>
        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem onClick={() => handleClose("help")} sx={{ m: 1 }}>
          Help
        </MenuItem>
        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem onClick={() => handleClose("logout")} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 360,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <HelpOutlineIcon />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Help
            </Typography>
          </Box>
          <IconButton onClick={() => setOpenDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        <Box sx={{ p: 2 }}>
          {/* Content */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Need Assistance?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              We’re here to help you with any queries related to orders,
              customers, or system usage.
            </Typography>
          </Box>
          {/* Contact Info */}
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <PhoneIcon />
            <Box>
              <Typography variant="body1" fontWeight={600}>
                Mobile
              </Typography>
              <Typography variant="body2">+91 7066055251</Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="center" mb={2} gap={2}>
            <WhatsAppIcon sx={{ color: "#25D366" }} />
            <Box>
              <Typography variant="body1" fontWeight={600}>
                WhatsApp
              </Typography>
              <Typography variant="body2">+91 7066055251</Typography>
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            <EmailIcon />
            <Box>
              <Typography variant="body1" fontWeight={600}>
                Email
              </Typography>
              <Typography variant="body2">support@posapp.com</Typography>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}
